import BaseService from './BaseService';

class AppConfigService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = frontendPath + "/app-config";
	}

	loadConfigFile(configFile) {
		const url = [this.serviceUrl, configFile].join("/");
		return this.opencellAPI.callApi(url);
	}
}

const appConfigService = new AppConfigService();
export default appConfigService;


// WEBPACK FOOTER //
// ./src/opencell/services/AppConfigService.js